<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-ums__videocourse">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.title" placeholder="标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.videoType"
                     placeholder="类型">
            <el-option v-for="item in videoTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('ums:videocourse:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('ums:videocourse:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
<!--        <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="title" label="标题" header-align="center" align="center"></el-table-column>
        <el-table-column prop="coverUrl" label="封面图" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.coverUrl" alt="" width="100" height="100">
          </template>
        </el-table-column>
<!--        <el-table-column prop="videoUrl" label="视频" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="videoType" label="视频类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.videoType===1">视频教程</el-tag>
            <el-tag v-else-if="scope.row.videoType===2">云客风采</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pageView" label="浏览量" header-align="center" align="center"></el-table-column>
        <el-table-column prop="attentionNum" label="关注量" header-align="center" align="center"></el-table-column>
        <el-table-column prop="orderSort" label="排序" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateDate" label="修改时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('ums:videocourse:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('ums:videocourse:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './videocourse-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/ums/videocourse/page',
        getDataListIsPage: true,
        exportURL: '/ums/videocourse/export',
        deleteURL: '/ums/videocourse',
        deleteIsBatch: true
      },
      videoTypes: [{
        value: 1,
        label: '视频教程'
      }, {
        value: 2,
        label: '云客风采'
      }],
      dataForm: {
        title: '',
        videoType: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
